import React from 'react';
import PropTypes from 'prop-types';
import Keyboard from 'react-simple-keyboard';
import { withStyles } from '@material-ui/core/styles';
import 'react-simple-keyboard/build/css/index.css';

export const KEYBOARD_KEYS = {
  backspace: '{bksp}',
  clear: '{clear}',
  hide: '{hide}',
  space: '{space}',
};

const KEYBOARD_LAYOUT = {
  default: [
    '1 2 3 4 5 6 7 8 9 0',
    'Q W E R T Z U I O P',
    'A S D F G H J K L',
    'Y X C V B N M Ä Ö Ü',
    'ß {space} {bksp} {clear} {hide}',
  ],
};

const KEYBOARD_DISPLAY = {
  [KEYBOARD_KEYS.backspace]: '⌫',
  [KEYBOARD_KEYS.clear]: 'Leeren',
  [KEYBOARD_KEYS.hide]: 'Ausblenden',
  [KEYBOARD_KEYS.space]: 'Leerzeichen',
};

export function applyOnScreenKeyboardKey(value, key) {
  const currentValue = value || '';

  switch (key) {
    case KEYBOARD_KEYS.backspace:
      return currentValue.slice(0, -1);
    case KEYBOARD_KEYS.clear:
      return '';
    case KEYBOARD_KEYS.space:
      return `${currentValue} `;
    default:
      return `${currentValue}${key}`;
  }
}

function OnScreenKeyboard({ classes, onKeyPress, onHide }) {
  const handleKeyPress = (key) => {
    if (key === KEYBOARD_KEYS.hide) {
      onHide();
      return;
    }

    onKeyPress(key);
  };

  return (
    <div
      className={classes.keyboard}
      role="application"
      aria-label="Bildschirmtastatur"
    >
      <Keyboard
        layout={KEYBOARD_LAYOUT}
        display={KEYBOARD_DISPLAY}
        onKeyPress={handleKeyPress}
        preventMouseDownDefault
        buttonTheme={[
          {
            class: classes.wideKey,
            buttons: KEYBOARD_KEYS.space,
          },
          {
            class: classes.actionKey,
            buttons: `${KEYBOARD_KEYS.backspace} ${KEYBOARD_KEYS.clear} ${KEYBOARD_KEYS.hide}`,
          },
        ]}
      />
    </div>
  );
}

const styles = (theme) => ({
  keyboard: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    maxHeight: '50vh',
    padding: '12px 16px',
    boxSizing: 'border-box',
    background: '#f5f5f5',
    borderTop: `1px solid ${theme.palette.divider}`,
    boxShadow: '0 -8px 20px rgba(0, 0, 0, 0.22)',
    zIndex: theme.zIndex.modal + 1,
    overflowY: 'auto',
    '& .simple-keyboard': {
      width: '100%',
      maxWidth: 1180,
      margin: '0 auto',
      padding: 0,
      background: 'transparent',
      fontFamily: 'inherit',
      overflow: 'visible',
    },
    '& .hg-rows': {
      display: 'block',
    },
    '& .hg-row': {
      justifyContent: 'center',
    },
    '& .hg-row:not(:last-child)': {
      marginBottom: 8,
    },
    '& .hg-row .hg-button:not(:last-child)': {
      marginRight: 8,
    },
    '& .hg-button': {
      flex: '1 1 0 !important',
      width: 'auto !important',
      minWidth: 0,
      maxWidth: 110,
      height: 54,
      minHeight: 54,
      margin: 0,
      borderRadius: 4,
      fontSize: '1.25rem',
      fontWeight: 700,
    },
    '& .hg-button span': {
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
  wideKey: {
    flex: '3 1 0 !important',
    maxWidth: '360px !important',
  },
  actionKey: {
    flex: '1.35 1 0 !important',
    maxWidth: '160px !important',
    fontSize: '1rem !important',
  },
});

OnScreenKeyboard.propTypes = {
  classes: PropTypes.object.isRequired,
  onKeyPress: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default withStyles(styles)(OnScreenKeyboard);
